import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('communication-system-buyer-guide', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./communication-system-buyer-guide-landing')
        ),
);
